export default "__VITE_ASSET__CuublseZ__"